import axios from '../axios-auth'

export const cashInHandReportService = {
    getCashInHandReport,
    getAllCashInHandReportList
}

function getCashInHandReport(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.counterId) {
        params["counterId"] = searchParams.counterId;
    }
    if (searchParams.date) {
        params["date"] = searchParams.date;
    }

    return axios.get("/auth/cash-in-hand-report", { params });
}

function getAllCashInHandReportList(searchParams) {
    let params = {};

    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.cashType) {
        params["cashType"] = searchParams.cashType;
    }
    if (searchParams.counterId) {
        params["counterId"] = searchParams.counterId;
    }
    if (searchParams.date) {
        params["date"] = searchParams.date;
    }
    return axios.get("/auth/cash-in-hand-report", { params });
}
